<!-- Profile Section -->
<app-profile></app-profile>

<!-- Main Menu -->
<nav class="sidebar-nav">
  <!-- Dashboard -->
  <a class="nav-item" routerLink="/dashboard" routerLinkActive="active">
    <div class="icon-wrapper">
      <mat-icon>dashboard</mat-icon>
    </div>
    <span>Dashboard</span>
  </a>

  <!-- Projects -->
  <a class="nav-item" routerLink="/projects" routerLinkActive="active">
    <div class="icon-wrapper">
      <mat-icon>folder</mat-icon>
    </div>
    <span>Projects</span>
  </a>

  <!-- Invites -->
  <a class="nav-item" routerLink="/invites" routerLinkActive="active">
    <div class="icon-wrapper">
      <mat-icon>person_add</mat-icon>
    </div>
    <span>Invites</span>
    @if (invitesCount() > 0) {
      <span class="badge">{{ invitesCount() }}</span>
    }
  </a>

  <!-- Notifications -->
  <a class="nav-item" routerLink="/notifications" routerLinkActive="active">
    <div class="icon-wrapper">
      <mat-icon>notifications</mat-icon>
    </div>
    <span>Notifications</span>
    @if (notificationService.unseenCount() > 0) {
      <span class="badge">{{ notificationService.unseenCount() }}</span>
    }
  </a>
</nav>

<!-- Bottom Menu -->
<div class="bottom-section">
  <!-- Help -->
  <a class="bottom-item" routerLink="/help" routerLinkActive="active">
    <div class="icon-wrapper">
      <mat-icon>info</mat-icon>
    </div>
    <span>Help</span>
  </a>

  <!-- Settings -->
  <a class="bottom-item" routerLink="/settings" routerLinkActive="active">
    <div class="icon-wrapper">
      <mat-icon>settings</mat-icon>
    </div>
    <span>Settings</span>
  </a>
</div>
